import React from 'react'
import classNames from 'classnames'
import './ActionBoxRowCell.scss'

const ActionBoxRowCell = ({ def, row, itemHover, isDisabled, isLastRow, isExpanded, isSelected }) => {
  const functionRenderer = (item) => typeof item === 'function' ? item(row) : item
  const iconColor = isSelected ? functionRenderer(def.selectedIconColor) : functionRenderer(def.iconColor)

  return (
    <div
      className={classNames(
        'viso-action-box-row-cell',
        itemHover && 'viso-action-box-row-cell--hover',
        isLastRow && 'viso-action-box-row-cell--last',
        isExpanded && 'viso-action-box-row-cell--expanded',
        def.icon && 'viso-action-box-row-cell--icon',
        isSelected && 'viso-action-box-row-cell--selected',
        def.className && (typeof def.className === 'function' ? def.className(row) : def.className),
        isExpanded && def.expandedClassName
      )}
    >
      {def.icon &&
        <div
          className={classNames(
            'viso-action-box-row-cell__icon',
            isDisabled && 'viso-text-label',
            !isDisabled && iconColor && `viso-text-${functionRenderer(iconColor)}`
          )}
        >
          {isSelected ? functionRenderer(def.selectedIcon) : functionRenderer(def.icon)}
        </div>
      }
      <div
        className={classNames(
          'viso-action-box-row-cell__text',
          isDisabled && 'viso-text-label',
          itemHover && 'viso-action-box-row-cell__text--hover',
          !itemHover && def.textColor && `viso-text-${def.textColor}`
        )}
      >
        {def.formatter ? def.formatter(row[def.key], row) : row[def.key]}
      </div>
    </div>
  )
}

export default ActionBoxRowCell